const players = {};
let playerCount = 0;

const loadYouTubeAPI = () => {
  const tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
};

window.onYouTubeIframeAPIReady = () => {
  document.querySelectorAll('.js-player').forEach((element) => {
    const playerContainer = element.closest('.js-playerFrame'); // divの時点で取得
    const playerId = `player-${playerCount}`;
    element.id = playerId;
    players[playerId] = {
      container: playerContainer, //
      instance: new YT.Player(playerId, {
        videoId: element.dataset.videoId,
        events: {
          onReady: (event) => onPlayerReady(event, element, playerId)
        }
      })
    };
    playerCount++;
  });
};

const onPlayerReady = (event, playerElement, playerId) => {
  const container = players[playerId].container;
  const button = container.querySelector('.js-play-button');
  // const frame = container.querySelector('.js-playerFrame');

  button.addEventListener("click", () => {
    const player = players[playerId];
    player.instance.playVideo();
    button.style.display = "none";
    container.classList.add("pv");
  });
};
const init = () => {
  loadYouTubeAPI();
};

export default init;